import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { ActivatedRoute } from '@angular/router';
import { filter } from 'rxjs';
import { SplashScreenService } from './nitro/services/splash-screen.service';
import { ThemeService } from './nitro/services/theme.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'app-nitro-management';

  constructor(
    private readonly splashScreenService: SplashScreenService,
    private readonly iconRegistry: MatIconRegistry,
    private readonly renderer: Renderer2,
    private readonly themeService: ThemeService,
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly platform: Platform,
    private readonly route: ActivatedRoute,
    private readonly msal: MsalService,
    private readonly msalBroadcast: MsalBroadcastService,
  ) {
    this.route.queryParamMap
      .pipe(filter((queryParamMap) => queryParamMap.has('style')))
      .subscribe((queryParamMap) => {
        if (queryParamMap.get('style') != null) {
          this.themeService.setStyle(queryParamMap.get('style') as string);
        }
      });

    this.iconRegistry.setDefaultFontSetClass('material-icons-outlined');
    this.themeService.theme$.subscribe((theme) => {
      if (theme[0]) {
        this.renderer.removeClass(this.document.body, theme[0]);
      }

      this.renderer.addClass(this.document.body, theme[1]);
    });

    if (this.platform.BLINK) {
      this.renderer.addClass(this.document.body, 'is-blink');
    }
  }

  ngOnInit() {}
}
